var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStatusChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_3280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 34.1169C1 35.3338 1.4834 36.5008 2.34386 37.3612C3.20432 38.2217 4.37136 38.7051 5.58824 38.7051C6.80511 38.7051 7.97215 38.2217 8.83261 37.3612C9.69307 36.5008 10.1765 35.3338 10.1765 34.1169C10.1765 32.9001 9.69307 31.7331 8.83261 30.8726C7.97215 30.0122 6.80511 29.5288 5.58824 29.5288C4.37136 29.5288 3.20432 30.0122 2.34386 30.8726C1.4834 31.7331 1 32.9001 1 34.1169Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5293 34.1169C28.5293 35.3338 29.0127 36.5008 29.8732 37.3612C30.7336 38.2217 31.9007 38.7051 33.1175 38.7051C34.3344 38.7051 35.5014 38.2217 36.3619 37.3612C37.2224 36.5008 37.7058 35.3338 37.7058 34.1169C37.7058 32.9001 37.2224 31.7331 36.3619 30.8726C35.5014 30.0122 34.3344 29.5288 33.1175 29.5288C31.9007 29.5288 30.7336 30.0122 29.8732 30.8726C29.0127 31.7331 28.5293 32.9001 28.5293 34.1169Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58789 20.3525V15.7644C5.58789 12.1138 7.0381 8.61282 9.61948 6.0315C12.2009 3.45017 15.702 2 19.3526 2C23.0032 2 26.5043 3.45017 29.0857 6.0315C31.6671 8.61282 33.1173 12.1138 33.1173 15.7644V20.3525",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 14L33 21L39 14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_3280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusChange);
export default __webpack_public_path__ + "static/media/icon_status_change.20c09ee3d8393d5bb937ed4560d82568.svg";
export { ForwardRef as ReactComponent };